/* eslint-disable react-hooks/exhaustive-deps */
import { useRecoilValue } from "recoil";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { ReflexContainer, ReflexElement, ReflexSplitter } from "react-reflex";

import { makeStyles } from "@material-ui/styles";
import {
    Checkbox,
    Divider,
    FormControlLabel,
    Snackbar,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";

import uiConf from "../../config/uiConf";

import apiClient from "../../lib/common/apiClient";
import checkValidation from "../../lib/utils/checkValidation";
import checkConditionWithMsg from "../../lib/utils/checkConditionWithMsg";

import Dialog from "../dialog/functional/Dialog";
import DialogContent from "../dialog/functional/DialogContent";
import DialogTitle from "../dialog/functional/DialogTitle";
import DialogActionsOkCancel from "../dialog/functional/DialogActionsOkCancel";
import DialogHeaderWithClose from "../dialog/functional/DialogHeaderWithClose";

import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

import AutoForm from "../form/functional/AutoForm";

import subMenuSelectionState from "../../states/subMenuSelectionState";
import getList from "../../lib/api/getList";
import { debounce } from 'lodash';
import getSpecific from "../../lib/api/getSpecific";
import getOption from "../../lib/api/getOptions";
import failureKey from "../../lib/common/failureKey";

const useStyles = makeStyles((theme) => ({
    keepOpenSwitch: {
        marginLeft: "8px",
    },

    label: {
        fontSize: "smaller",
        color: theme.palette.primary.text,
    },
}));

function EguPopInputMaterialDialog(props) {

    const classes = useStyles();

    const {
        id,
        mode,
        schema,
        onSelectMst,
        onUpdateMaster,

        title,
        formId,

        moveable,
        resizable,
        fullWidth,
        maxWidth,

        onInitialized,
        onSuccess,
        onClose,

        onDialogUpdateDetail,

        ...others
    } = props;

    const [keepOpen, setKeepOpen] = useState(false);
    const [disabled, setDisabled] = useState(true);
    const [formData, setFormData] = useState({});
    const [initialData, setInitailData] = useState({});
    const [currentInputQty, setCurrentInputQty] = useState();

    const [instance, setInstance] = useState();
    const [isEmpty, setIsEmpty] = useState();

    const [lineNo, setLineNo] = useState();
    const [, setApi] = useState();
    const [apiInputQty, setApiInputQty] = useState();

    const [grid, setGrid] = useState();
    const [gridInputQty, setGridInputQty] = useState();

    const [height, setHeight] = useState(0);

    const menuInfo = useRecoilValue(subMenuSelectionState);

    const [notification, setNotification] = useState({
        open: false,
        severity: "success",
        msg: "",
    });

    const [priorityLot, setPriorityLot] = useState([]);

    const [specificWarehouse, setSpecificWarehouseOption] = useState();

    const searchRef = useRef();

    const onViewInitialized = (grid) => {
        grid.selectionMode = "Row"
        setGrid(grid)
    }
    const onViewInitializedInputQty = (grid) => {
        grid.selectionMode = "Row"
        setGridInputQty(grid)
    }
    const onApiInitialized = (api) => {
        setApi(api)
    }
    const onApiInitializedInputQty = (api) => {
        setApiInputQty(api)
    }

    const handleResize = () => {

        setHeight(document.documentElement.offsetHeight - 96);

    };
    useEffect(() => {

        window.addEventListener('resize', handleResize);

        handleResize();

        return () => window.removeEventListener('resize', handleResize);

    }, []);

    useEffect(() => {

        let mounted = true;

        (async () => {

            let option = await getOption("acquisition", "specificWarehouse");
            let result = await getList('MomSysUdtLineNo');

            if (mounted) {
                setSpecificWarehouseOption(option);
                setLineNo(result?.data[0]?.lineNo ? result?.data[0]?.lineNo : undefined)

            }

        })();

        return (() => {

            mounted = false;

        });

    }, []);

    useEffect(() => {

        let mounted = true;

        if (onSelectMst.planId && onSelectMst.bopMaterialCode && onSelectMst.bopMaterialCodeVer && onSelectMst.processCode && others.open) {

            (async () => {

                let result = await getSpecific('EguVwPrePopProductManageDetail', onSelectMst?.planId, onSelectMst.bopMaterialCode, onSelectMst.bopMaterialCodeVer, onSelectMst.processCode);

                if (mounted) {

                    setPriorityLot(result?.lotNoArray);

                }

            })();
        }

        return (() => {

            mounted = false;

        });

    }, [onSelectMst.planId, onSelectMst.bopMaterialCode, onSelectMst.bopMaterialCodeVer, onSelectMst.processCode, others.open])

    useEffect(() => {

        (async () => {

            if (grid) {
                grid.selectionChanged.addHandler(debounce((grid, event) => {
                    if (grid.selectedItems && grid.selectedItems[0]) {

                        setInitailData(grid.selectedItems[0]);

                    } else {
                        setInitailData({})

                    }

                }, 10));

                grid.itemsSourceChanged.addHandler(debounce((grid, event) => {
                    if (grid.selectedItems && grid.selectedItems[0]) {

                        setInitailData(grid.selectedItems[0])

                    } else {
                        setInitailData({})

                    }

                }, 10));

            }

        })()

    }, [grid]);

    useEffect(() => {

        if (grid) {
            (async () => {

                grid.loadedRows.addHandler((grid, event) => {
                    for (let row of grid.rows) {
                        if (priorityLot.includes(row.dataItem.lotNo)) {

                            row.cssClass = `qty-equals-blue`;

                        } else {

                            row.cssClass = null;

                        }
                    }

                });


            })()

            grid.onLoadedRows();

            return () => {
                grid.loadedRows.removeHandler();
            }
        }

    }, [grid, priorityLot]);

    useEffect(() => {

        (async () => {

            if (gridInputQty) {

                gridInputQty.selectionChanged.addHandler(debounce((grid, event) => {

                    if (grid.selectedItems && grid.selectedItems[0]) {

                        setCurrentInputQty(grid.selectedItems[0]?.inputQty);

                    } else {
                        setCurrentInputQty(null)

                    }

                }, 10));

                gridInputQty.itemsSourceChanged.addHandler(debounce((grid, event) => {

                    if (grid.selectedItems && grid.selectedItems[0]) {

                        setCurrentInputQty(grid.selectedItems[0]?.inputQty)

                    } else {
                        setCurrentInputQty(null)

                    }

                }, 10));

            }

        })()

    }, [gridInputQty]);

    useEffect(() => {
        if (apiInputQty) {
            apiInputQty.refresh();
        }
    }, [initialData])

    useEffect(() => {
        if (isEmpty) {
            setInitailData(() => {
                return {};
            })
        }
    }, [isEmpty])

    useEffect(() => {

        if (initialData) {

            setFormData((preFormData) => {

                let requiredQty = initialData.requiredQty - currentInputQty > 0 ? initialData.requiredQty - currentInputQty : 0;
                let newFormData = {
                    ...preFormData,
                    materialCode: initialData.materialCode,
                    materialCodeVer: initialData.materialCodeVer,
                    inputQty: initialData.qtyCurrent > requiredQty ? requiredQty : initialData.qtyCurrent,
                    materialName: initialData.materialName,
                    lotNo: initialData.lotNo,
                    orderBuyerId: initialData.productOrderBuyerId,
                    requiredQty: initialData.requiredQty,
                    menuInfo: menuInfo,
                    process: onSelectMst.category,
                    lineNo: onSelectMst.lineNo,
                };
                return newFormData;
            });

        }
    }, [initialData, menuInfo, onSelectMst, lineNo, currentInputQty]);

    useEffect(() => {

        if (formData && initialData) {

            if (formData.inputQty === initialData.requiredQty) {

                setDisabled(false)
            }
        }

    }, [formData, initialData])

    const { t } = useTranslation();

    const onCloseDialog = () => {

        setDisabled(true);

        setFormData((formData) => {

            let newFormData = {
                ...formData,
                materialCode: undefined,
                materialCodeVer: undefined,
                inputQty: undefined,
                materialName: undefined,
                lotNo: undefined,
                orderBuyerId: undefined,
                requiredQty: undefined,
                menuInfo: undefined,
                process: undefined,
                bringMaterialDate: undefined,
            }

            return newFormData
        })

        if (onClose) {

            onClose();

        }

        if (onUpdateMaster) {

            onUpdateMaster()

        }

    };

    const onCancel = () => {

        setFormData((formData) => {

            let newFormData = {
                ...formData,
                materialCode: undefined,
                materialCodeVer: undefined,
                inputQty: undefined,
                materialName: undefined,
                lotNo: undefined,
                orderBuyerId: undefined,
                requiredQty: undefined,
                menuInfo: undefined,
                process: undefined,
                bringMaterialDate: undefined,
            }

            return newFormData
        })

        setDisabled(true);

        instance.hide();

        if (onUpdateMaster) {

            onUpdateMaster()

        }

    };

    const onDialogInitialized = (instance) => {
        setInstance(instance);

        if (onInitialized) {

            onInitialized(instance);

        }
    };

    const onChange = (formData) => {

        setFormData(formData);

    };

    const notifyFailure = (msg) => {
        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });
    };

    const nofifyWarning = (msg) => {

        setNotification({
            severity: "warning",
            msg: msg,
            open: true,
        });
    };

    const onApiFailure = (reason) => {
        notifyFailure(
            t(failureKey("insert", reason.response?.status), {
                reason: reason.response
                    ? reason.response.data
                    : JSON.stringify(reason),
            })
        );
    };

    const onApiSuccess = (result) => {
        grid.selectedItems[0].inputQty = grid.selectedItems[0]?.inputQty + formData.inputQty;
        grid.selectedItems[0].qtyCurrent = grid.selectedItems[0]?.qtyCurrent - formData.inputQty
        grid.refresh(false)

        if (onSuccess) {

            setTimeout(onSuccess(result.msg), 0);

        }

        if (!keepOpen) {

            instance.hide();

            if (onUpdateMaster) {

                onUpdateMaster()

            }


        }

        if (apiInputQty) {

            apiInputQty.refresh();

        }

        if (onSelectMst.planId && onSelectMst.bopMaterialCode && onSelectMst.bopMaterialCodeVer && onSelectMst.processCode && others.open) {

            (async () => {

                let result = await getSpecific('EguVwPrePopProductManageDetail', onSelectMst?.planId, onSelectMst.bopMaterialCode, onSelectMst.bopMaterialCodeVer, onSelectMst.processCode);



                setPriorityLot(result?.lotNoArray);


            })();
        }
    };

    const checkItemValidation = (schema, formData) => {

        for (const column of schema.columns) {

            let [valid, msg] = checkValidation(
                "create",
                column,
                column.validation,
                formData[column.name] || ""
            );

            if (!valid) {
                nofifyWarning(msg);
                return false;
            }
        }

        return true;
    };

    const checkInStock = (formData) => {

        if ((Math.round(parseFloat(initialData?.qtyCurrent) * 10000) / 10000) < (Math.round(parseFloat(formData.inputQty) * 10000) / 10000)) {
            nofifyWarning(t("warning.outOfStock"));
            return false
        }
        return true;
    }

    const checkInput = (formData) => {

        if ((Math.round(parseFloat(formData.inputQty) * 10000) / 10000) <= 0) {
            nofifyWarning(t("warning.invalidQty"));
            return false
        }
        return true;
    }

    const checkWareHouse = (formData) => {
        if (initialData.wareHouseCode === 'W000' && (parseFloat((formData.inputQty).toFixed(6)) !== parseFloat((initialData.qtyCurrent).toFixed(6)))) {
            nofifyWarning(t("warning.notSplitOnTheLine"))
            return false
        }
        return true;
    }

    const roundQty = (formData) => {
        formData.inputQty = Math.round(formData.inputQty * 10000) / 10000;
    }
    const onOk = (schema, formData) => {
        if (!checkInStock(formData)) {
            return;
        }

        if (!checkInput(formData)) {
            return;
        }

        if (!checkWareHouse(formData)) {
            return;
        }

        if (!checkItemValidation(schema, formData)) {

            console.error(" From Validation Failed ");

            return;
        }

        roundQty(formData);

        if (schema.validation) {

            let [valid, msg] = checkConditionWithMsg(
                formData,
                schema.validation
            );

            if (!valid) {
                nofifyWarning(
                    t("warning.formDataValidationFail", { msg: msg })
                );
                return;
            }
        }

        let url = `/api/EguPopProductManage/material/${onSelectMst?.planId}`;

        let apiData = { ...formData };

        let form = new FormData();

        let json = {};
        let deleted = {};

        for (const formItem in apiData) {
            if (apiData[formItem] !== undefined) {
                json[formItem] = apiData[formItem];
            }
        }

        form.append("deleted", JSON.stringify(deleted));
        form.append("json", JSON.stringify(json));

        apiClient
            .post(url, form, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((result) => onApiSuccess(result.data))
            .catch((reason) => onApiFailure(reason));
    };

    const onCloseNotification = () => {
        setNotification((notification) => {
            return { ...notification, open: false };
        });
    };

    const checkKeepOpen = () => {
        return (
            <>
                <FormControlLabel
                    control={
                        <Checkbox
                            className={classes.keepOpenSwitch}
                            checked={keepOpen}
                            color="primary"
                            onChange={() =>
                                setKeepOpen((keepOpen) => !keepOpen)
                            }
                            name="checkKeepOpen"
                            size="small"
                        />
                    }
                    label={
                        <span className={classes.label}>
                            {t("term.keepDialogOpen")}
                        </span>
                    }
                />
                <div style={{ flexGrow: 1 }}></div>
            </>
        );
    };

    const onModifyViewUrl = (url, planId, specificWarehouse) => {

        return url + "/" + planId + "/" + specificWarehouse;

    }

    const onModifyViewUrlInputQty = (url, planId, materialCode, materialCodeVer) => {

        return url + "/" + planId + "/" + materialCode + "/" + materialCodeVer;

    }

    const onLoadData = (data) => {

        setIsEmpty(data.length < 1 ? true : false)

    };

    return (
        <>
            <Dialog
                id={id}
                moveable={moveable ? moveable : uiConf.dialogMoveable}
                resizable={resizable ? resizable : uiConf.dialogResizable}
                fullWidth={fullWidth ? fullWidth : uiConf.dialogFullWidth}
                maxWidth="xl"
                onClose={onCloseDialog}
                onInitialized={onDialogInitialized}
                {...others}
            >
                <DialogHeaderWithClose>
                    <DialogTitle>{title}</DialogTitle>
                </DialogHeaderWithClose>

                <Divider />

                <DialogContent
                    style={{ height: height }}
                >
                    <ReflexContainer orientation="vertical">
                        <ReflexElement flex={0.7} data-cy="dialogMaster">
                            <BasicCrudScreenType
                                id={formId}
                                embededInOtherScreenType
                                headerTitle={
                                    `${onSelectMst?.materialName}, ${onSelectMst?.processName}`
                                }
                                headerTitleStyle={{
                                    fontSize: "1.5em",
                                    fontWeight: "bold",
                                    marginLeft: "8px",
                                    marginTop: "10px",
                                }}
                                table="EguPopProductManageDetail"
                                view="EguVwPrePopProductManageDetail"
                                onModifyViewUrl={(url) => onModifyViewUrl(url, onSelectMst?.planId, specificWarehouse)}
                                noCreate
                                noEdit
                                noDelete
                                noExcel
                                noOutputSize
                                noFilter
                                onInitialized={onViewInitialized}
                                onApiInitialized={onApiInitialized}
                                onLoadData={onLoadData}
                                searchRef={searchRef}
                            />
                        </ReflexElement>
                        <ReflexSplitter />
                        <ReflexElement>
                            <ReflexContainer>
                                <ReflexElement>
                                    <div
                                        style={{
                                            padding: "32px",
                                        }}
                                    >
                                        <AutoForm
                                            id="EguPopInputMaterialDialog"
                                            schema={schema}
                                            mode="edit"
                                            initialData={formData}
                                            onChange={onChange}
                                        />
                                    </div>
                                </ReflexElement>
                                <ReflexSplitter />
                                <ReflexElement>
                                    <BasicCrudScreenType
                                        id={formId}
                                        embededInOtherScreenType
                                        table="EguVwPopProductManageDetail"
                                        view="EguVwPopProductManageDetail"
                                        onModifyViewUrl={(url) => onModifyViewUrlInputQty(url, onSelectMst?.planId, initialData?.materialCode, initialData?.materialCodeVer)}
                                        noCreate
                                        noEdit
                                        noDelete
                                        noExcel
                                        noOutputSize
                                        noSearch
                                        noFilter
                                        onInitialized={onViewInitializedInputQty}
                                        onApiInitialized={onApiInitializedInputQty}

                                    />
                                </ReflexElement>
                            </ReflexContainer>


                        </ReflexElement>
                    </ReflexContainer>

                    <Snackbar
                        open={notification.open && notification.severity !== "success"}
                        autoHideDuration={uiConf.dialogNotifyAutoHideDuration}
                        onClose={onCloseNotification}
                    >
                        <Alert
                            onClose={onCloseNotification}
                            variant="filled"
                            severity={notification.severity}
                        >
                            {notification.msg}
                        </Alert>
                    </Snackbar>
                </DialogContent>

                <Divider />

                <DialogActionsOkCancel
                    firstActionComponent={checkKeepOpen}
                    labels={[t("common.add")]}
                    buttonDisabled={[disabled, false]}
                    onOk={() => onOk(schema, formData)}
                    onCancel={onCancel}
                ></DialogActionsOkCancel>
            </Dialog>
        </>
    );
}

export default EguPopInputMaterialDialog;
